// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// 引入英文
import locale from 'element-ui/lib/locale/lang/en'
// import axios from 'axios'
// 引入全局 css
import './assets/css/index.css'
import './assets/css/button.css'
import './assets/css/page.css'
import './assets/css/documentation.css'
import './assets/css/browse.css'
import './assets/iconfont/iconfont.css'

// 引入qs
import qs from 'qs'

// pinia
import { PiniaVuePlugin, createPinia } from 'pinia'
import { useStore } from '@/store/pinia'

// 这是 SSO
import { getToken } from '@/utils/auth'

Vue.prototype.$qs = qs

Vue.use(Element, { locale })

// Vue.prototype.$axios = axios

// pinia
Vue.config.productionTip = false
Vue.use(PiniaVuePlugin)
const pinia = createPinia()
Vue.prototype.$store = useStore

// TODO
// Vue.prototype.$imageUrl = 'http://localhost:8081/obia/api/obia_image/'
Vue.prototype.$imageUrl = '/obia/api/obia_image/'

// 下载
Vue.prototype.$downloadUrl = 'https://download.cncb.ac.cn/obia'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  pinia,
  components: { App },
  template: '<App/>'
})
// 这是 SSO
router.beforeEach((to, from, next) => {
  const store = useStore()
  if (!to.meta.requireAuth) {
    store.setRoutePath(to.path)
    next()
  } else {
    if (getToken()) {
      store.setRoutePath(to.path)
      next()
    } else {
      // TODO
      window.location.href =
        // 'http://192.168.164.84:9131/sso/login?service=http://localhost:8081/obia/api/login'
        'https://ngdc.cncb.ac.cn/sso/login?service=https://ngdc.cncb.ac.cn/obia/api/login'
    }
  }
})

// 页面跳转到顶部
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})



// WEBPACK FOOTER //
// ./src/main.js